import { HttpClient } from "@angular/common/http";
import { DataService } from "../../core/services/data.service";
import { NotificationService } from "../../core/services/notification.service";
import { environment } from "../../../environments/environment";
import { Injectable } from "@angular/core";
import { Observable } from "rxjs";
import { ActionDataResult } from "../models/core/ActionDataResult";
import { RequestPaymentItem } from "../models/payonline/request-payment-item";
import { CreatePaymentLinkRequest } from "../models/payonline/create-payment-link-request";
import { CreatePaymentLinkResult } from "../models/payonline/create-payment-link-result";

@Injectable()
export class PaymentsService extends DataService<any, any> {
    
    constructor(http: HttpClient, notificationService: NotificationService) {
        super(http, notificationService);
        this.controllerName = 'payments';
    }

    public createOrder(requestId: number): Observable<ActionDataResult<number>> {
		return this.postQuery<number>(`${environment.apiUrl}v${this.controllerVersion}/${this.controllerName}/create-order/${requestId}`, null);
	}

	public getRequestPayments(requestId: number): Observable<RequestPaymentItem[]> {
		return this.getQuery<RequestPaymentItem[]>(`${environment.apiUrl}v${this.controllerVersion}/requests/${requestId}/payments`);
	}

	public createPaymentLink(requestId: number, request: CreatePaymentLinkRequest): Observable<ActionDataResult<CreatePaymentLinkResult>> {
		return this.postQuery<CreatePaymentLinkResult>(
			`${environment.apiUrl}v${this.controllerVersion}/${this.controllerName}/create-payment-link/${requestId}`,
			request);
	}
}